module.exports = __webpack_public_path__ + "videos/3d_cn.69a00d8.mp4";